import angular from 'angular';
import optionSwitchComponent from './optionSwitch.component';

let optionSwitchModule = angular.module('optionSwitch', [
])

.component('optionSwitch', optionSwitchComponent)

.name;

export default optionSwitchModule;



// WEBPACK FOOTER //
// ./client/app/components/optionSwitch/optionSwitch.js